<template>
    <div>
        We have been tracking your switch <span v-if="supplier">to <b>{{ supplier.name }}</b></span> at {{currentPropertyAddress}} and unfortunately
        there has been an objection to your supplies moving. <br>
        This could be for a number of reasons, outstanding debt on your account or you may still be within a fixed term period.<br>
        
        However, you don't need to worry, just contact your current supplier and they will help you resolve any outstanding issues.<br>
        Once the issue is resolved, please notify our customer team on <a href="mailto:helpdesk@myswitchpro.com">helpdesk@myswitchpro.com</a> or contact us via the
        <router-link :to="{name: 'Help'}">Helpdesk</router-link>
        option under the profile menu, so we can restart your switch <span v-if="supplier">to <b>{{ supplier.name }}</b></span>.
    </div>
</template>

<script>
import api from "@/utils/api";

export default {
    name: "SwitchObjection",
    props: {
        notification: Object
    },
    data() {
        return {
            supplier: null,
            currentPropertyAddress: null
        }
    },
    mounted() {
        let that = this;
        api.getRecommendation(this.notification.payload.recommendation_id, {
            recommendations: {fields: ['product','property']},
            products: {fields: ['supplier']},
            supplier: {fields: ['name']},
            properties: {fields: ['currentPropertyAddress']}
        }).then(response => {
            that.supplier = response.data.data.product.supplier
            that.currentPropertyAddress = response.data.data.property.currentPropertyAddress
        })
    }
}
</script>

<style scoped>

</style>
